import { createAction } from 'redux-actions';

import { AUTH, LOGOUT, UPDATE_USER_DATA, SET_UBS_DOMAIN } from './types';

export const signIn = createAction(AUTH);
export const logout = createAction(LOGOUT);
export const updateUserData = createAction(UPDATE_USER_DATA);
export const setUBSdomain = createAction(SET_UBS_DOMAIN);
